import React, { Fragment, memo } from 'react'
import tw from 'twin.macro'
import { Tooltip, Typography } from '@mui/material'
import { QuestionMarkMinor } from '@shopify/polaris-icons'
import { colors } from 'src/theme'
import { CARD_BORDER_COLOR } from '../constants'

const ContractorStepDetailsDelayedBannerComponent = () => (
  <Fragment>
    <div css={tw`pb-4 flex flex-row items-center`}>
      <Typography css={tw`mr-1`} variant="overline">
        DELAYED STEP
      </Typography>
      <Tooltip
        color="black"
        title={
          <Fragment>
            <Typography css={tw`mb-2`} variant="h6" color={colors.SHADES_GREY_200}>
              Delayed step
            </Typography>
            <Typography variant="body2" color={colors.SHADES_GREY_300}>
              A step the contractor cannot complete without a prior step being approved first. To
              initiate this step for a contractor, please approve all steps in 'Waiting for
              Approval' tab. They will then be sent a notification with a link to continue
              onboarding.
            </Typography>
          </Fragment>
        }
        placement="right-end"
      >
        <span css={tw`h-5 cursor-pointer`}>
          <QuestionMarkMinor width={20} />
        </span>
      </Tooltip>
    </div>
    <div css={tw`mb-4 border-0 border-b border-solid`} style={{ borderColor: CARD_BORDER_COLOR }} />
  </Fragment>
)

export const ContractorStepDetailsDelayedBanner = memo(ContractorStepDetailsDelayedBannerComponent)
